<template>
    <div>
        <vs-table :data="yearlyPrices" class="noscroll">
            <template slot="thead" >
                <vs-th width="200px">{{ $t("CashFlow.ElementYearlyPrice.Element")}}</vs-th>
                <vs-th width="110px" style="min-width: 110px;" v-for="(year, index) in years" :key="index">
                    <span>
                        {{ year }}
                    </span>
                </vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr v-for="d in data" :key="d.element">
                    <vs-td :data="d.element">
                        <vs-row>
                            <vs-col>
                                {{ getElementName(d.element) }}
                            </vs-col>
                        </vs-row>
                    </vs-td>
                    <vs-td :data="d.values[index].price" align="center" v-for="(value, index) in d.values" :key="index">
                        <ValidationProvider :name="$t('CashFlow.ElementYearlyPrice.Price')" immediate rules="required|decimal|min_value:0" v-slot="{ errors }">
                            <vs-input :disabled="readOnly" v-model="d.values[index].price" class="w-full" v-if="d.values[index].id!=null" v-on:change="onEditPrice($event, d.values[index].id)" />
                                <span v-if="d.values[index].id==null">N/A</span>
                            <validation-message>{{ errors[0] }}</validation-message>
                        </ValidationProvider>
                    </vs-td>
                </vs-tr>
            </template> 
        </vs-table>
    </div>
</template>

<script>

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    yearlyPrices: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false,
      context: { componentParent: this }
    };
  },

  computed: {
    years () {
      return this.$props.yearlyPrices.map(item => item.values.map(v => v.year))[0];
    }
  },

  methods: {
    getElementName(element) {
      return this.$t("Element." + element);
    },
    onEditPrice(event, elementYearlyPriceId) {
      const value = event.target.value;
      if (value === null || value === "") {
        return;
      }

      if (Number(value) === 0) {
        this.deletePrice(elementYearlyPriceId);
        return;
      }

      this.$cqrsPost('cashflow/lom/elementYearlyPriceTemplates/EditElementYearlyPrice', { 
        id: elementYearlyPriceId,
        price: value
      }).finally(() => {
        this.$vs.loading.close();
      });
    },

    deletePrice(elementYearlyPriceId) {
      this.$cqrsPost('cashflow/lom/elementYearlyPriceTemplates/DeleteElementYearlyPrice', { 
        id: elementYearlyPriceId
      }).then(() => {
        const flattenedYearlyPrices = this.yearlyPrices.flatMap(x => x.values);
        const nowDeletedPrice = flattenedYearlyPrices.find(x => x.id === elementYearlyPriceId);
        nowDeletedPrice.id = null;
        nowDeletedPrice.price = null;
      }).catch((response) => {
        console.log(response);
      });
      
    }
  }
};
</script>

<style lang="scss">
  .noscroll {
    overflow: initial !important;
  }

</style>